<script setup>
import {useMiscStore} from "@/stores/misc";

const props = defineProps({
  title: {
    default: 'Ghana Connect',
    type: String
  },
  mainTitle: {
    default: 'Akwaaba',
    type: String
  },
  mainTitlePath: {
    default: '/',
    type: String
  },
  subtitle: {
    default: 'Together, we build a network that thrives on collaboration and connection.',
    type: String
  },
  description: {
    default: () => [],
    type: Array
  },
  sectorDescription: {
    default: null,
    type: String,
    required: false,
  },
  callToAction: {
    default: null,
    type: String
  },
  usedBy: {
    type: String,
    required: false,
  },
}),
    miscStore = useMiscStore();
</script>

<template>
  <div
    class="py-7 px-2 md:px-6 lg:px-8 md:pb-20 flex justify-center flex-col bg-contain"
    style="min-height: 50vh"
  >
    <div class="container text-left mx-auto mt-2 mb-8 md:mt-10 w-full">
      <h2 :class="['font-semibold mb-6 break-all drop-shadow-sm', props.title === 'Ghana Connect' ? 'text-xl md:text-6xl' : 'text-xl md:text-6xl']">
        <router-link :to="props.mainTitlePath">
          <span class="text-red-500 block">{{ props.mainTitle }}</span>
        </router-link>
      </h2>
      <h1
        :class="[
          'h1 text-5xl md:text-7xl lg:text-9xl mb-4 font-bold logo-title drop-shadow-sm',
          props.title === 'Ghana Connect'
            ? 'text-gray-800'
            : 'text-blue-50'
        ]"
      >
        {{ props.title }}
      </h1>
      <h2
        v-if="props.title === 'Ghana Connect'"
        :class="['font-bold text-lg md:text-2xl xl:text-3xl mb-4 drop-shadow-none',
                 props.title === 'Ghana Connect'
                   ? 'text-gray-600'
                   : 'text-blue-100'
        ]"
      >
        <span
          v-for="sector in miscStore.sectors"
          :key="sector.id"
        >
          <span v-if="sector.name === 'Home' || sector.name === 'About Us'" />
          <span v-else>{{ sector.name }},  </span>
        </span>
      </h2>
      <p
        :class="[
          'h3 font-medium text-sm md:text-lg lg:text-xl my-2 md:my-2 drop-shadow-sm',
          props.title === 'Ghana Connect'
            ? 'text-gray-800'
            : 'text-blue-50'
        ]"
        v-html="props.subtitle"
      />

      <div
        v-if="!props.sectorDescription"
        class="text-center"
      >
        <p
          v-for="(paragraph, index) of props.description"
          :key="index"
          :class="[
            'text-sm md:text-lg font-medium pt-4 break-all drop-shadow-sm',
            props.title === 'Ghana Connect'
              ? 'text-gray-800'
              : 'text-blue-50'
          ]"
        >
          {{ paragraph }}
        </p>
      </div>
      <p
        v-else
        :class="[
          'text-sm md:text-lg font-medium pt-2 lg:pt-2 text-center break-all drop-shadow-sm',
          props.title === 'Ghana Connect'
            ? 'text-gray-800'
            : 'text-blue-50'
        ]"
        v-html="props.sectorDescription"
      />
      <!--      <p class="text-gray-100 text-sm md:text-lg font-medium pt-2 lg:pt-4 text-center break-all drop-shadow-sm">-->
      <!--        {{ props.callToAction }}-->
      <!--      </p>-->
    </div>
  </div>
</template>

<style scoped>
.logo-title {
  font-family: Roboto, Avenir, Helvetica, Arial, system-ui, sans-serif;
}

.text-cyellow {
  color: #fcc816;
}

.text-cred {
  color: #ce1125;
}
</style>
